import React from "react";
import RevokeReferral from "./RevokeReferral";
import { ButtonsWrapper } from "../../AddMember.style";
import ButtonSendReferral from "./ButtonSendReferral";
import ButtonAdd from "./ButtonAdd";
import { ImmutableChat, IUserInfo } from "@home-health-notify/domain";
import { ADD_USER_TYPE, SelectedUserType } from "hhn-commons";

type ActionButtonsType = {
  userInfo: IUserInfo;
  onAddUser: (selectedId: string, title: string) => void;
  onSendReferral: (selectedId: string, title: string) => void;
  userSelected: SelectedUserType | undefined;
  hasReferral: boolean;
  canSendReferral: boolean;
  chat: ImmutableChat | undefined;
};
export const ActionButtons = ({
  userInfo,
  onAddUser,
  onSendReferral,
  userSelected,
  hasReferral,
  canSendReferral,
  chat,
}: ActionButtonsType) => {
  const isUserSelected =
    (userSelected && userSelected.type === ADD_USER_TYPE.USER) || false;
  const isUserReferralSelected =
    (userSelected && userSelected.type === ADD_USER_TYPE.REFERRAL) || false;

  return (
    <ButtonsWrapper data-testid="action-buttons">
      {hasReferral && canSendReferral ? (
        <RevokeReferral chat={chat as ImmutableChat} userInfo={userInfo} />
      ) : (
        <>
          {canSendReferral && (
            <ButtonSendReferral
              onClick={() => onSendReferral(userInfo.id, userInfo.title)}
              isUserReferralSelected={isUserReferralSelected}
            />
          )}
          {!hasReferral && (
            <ButtonAdd
              isSelected={isUserSelected}
              onClick={() => onAddUser(userInfo.id, userInfo.title)}
            />
          )}
        </>
      )}
    </ButtonsWrapper>
  );
};
